import React from 'react';
import { isLinkItem } from '../utils/utils';
import InternalIcon from '../../icon/internal';
var ExternalIcon = function (_a) {
    var item = _a.item;
    var disabled = item.disabled, external = item.external, externalIconAriaLabel = item.externalIconAriaLabel;
    if (!external) {
        return null;
    }
    var icon = React.createElement(InternalIcon, { variant: disabled ? 'disabled' : 'normal', name: "external" });
    return externalIconAriaLabel ? (React.createElement("span", { role: "img", "aria-label": externalIconAriaLabel }, icon)) : (icon);
};
var LinkItem = function (_a) {
    var item = _a.item, disabled = _a.disabled, itemRef = _a.itemRef, onClick = _a.onClick;
    if (!isLinkItem(item)) {
        return null;
    }
    return (
    // eslint-disable-next-line react/jsx-no-target-blank
    React.createElement("a", { ref: itemRef, href: !disabled ? item.href : undefined, onClick: !disabled ? onClick : undefined, target: item.external ? '_blank' : undefined, rel: item.external ? 'noopener noreferrer' : undefined },
        item.text,
        " ",
        React.createElement(ExternalIcon, { item: item })));
};
export default LinkItem;
//# sourceMappingURL=link-item.js.map